// extracted by mini-css-extract-plugin
export default {"image":"OX-z","loaded":"PX-z"};